/** Pagine semplici: elenco stack, porte, registro, utenti, importazione. */
export const pagine = {
  "stacks.titolo": "Stack",
  "stacks.intro": "Configurazioni salvate e loro stato di esecuzione.",
  "stacks.importa": "Importa",
  "stacks.nuovo": "Nuovo stack",
  "stacks.blueGreen": "blue/green",
  "stacks.ricreazione": "ricreazione",
  "stacks.aggiornato": (p: { quando: string }) => `aggiornato il ${p.quando}`,
  "stacks.nonAvviato": "non avviato",
  "stacks.fermo": "fermo",
  "stacks.attivo": "attivo",
  "stacks.daApplicare": "da applicare",
  "stacks.errore": "errore",
  "stacks.cerca": "Cerca uno stack",
  "stacks.tuttiStati": "Tutti gli stati",
  "stacks.filtroStato": "Filtra per stato",
  "stacks.colStack": "Stack",
  "stacks.colStato": "Stato",
  "stacks.colStrategia": "Strategia",
  "stacks.colDominio": "Dominio",
  "stacks.colContainer": "Container",
  "stacks.colTag": "Tag",
  "stacks.tagTitolo": (p: { stack: string }) => `Cambia il tag di ${p.stack}`,
  "stacks.tagTesto": (p: { variabile: string }) =>
    `Viene salvata una nuova revisione con ${p.variabile} aggiornata e lo stack viene rilasciato subito.`,
  "stacks.tagPrecedenti": "Rilasciati in precedenza",
  "stacks.tagInUso": "in uso",
  "stacks.tagConferma": (p: { tag: string }) => `Rilascia ${p.tag}`,
  "stacks.modificaTag": "Cambia il tag e rilascia",
  "stacks.tagAggiornato": (p: { tag: string }) => `Rilasciato con il tag ${p.tag}`,
  "stacks.tagSenzaEsito": "Il rilascio si è interrotto senza un esito",
  "stacks.colRilascio": "Ultimo rilascio",
  "stacks.revisione": (p: { n: number }) => `rev. ${p.n}`,
  "stacks.nessunoCorrisponde": "Nessuno stack corrisponde",
  "stacks.azzeraFiltri": "Azzera filtri",
  "stacks.vuotoCosaFa": "Portman avvia i tuoi stack Docker Compose e ne tiene la configurazione.",
  "stacks.vuotoCosaFa2": "Ogni modifica diventa una revisione che puoi rilasciare, e annullare se serve.",
  "stacks.importaEsistente": "Importa uno stack esistente",
  "stacks.inEsecuzione": "in esecuzione",

  "porte.titolo": "Porte",
  "porte.intro": "Assegnazioni gestite da Portman e porte occupate da altri container sull'host.",
  "porte.riepilogo": (p: { da: number; a: number; assegnate: string; libere: string }) =>
    `Intervallo ${p.da}–${p.a} · ${p.assegnate} assegnate · ${p.libere} libere`,
  "porte.comeChiederla": "Per avere una porta, dichiarala nel compose come variabile, ad esempio",
  "porte.esempio": '"${PORT_WEB}:80"',
  "porte.colPorta": "Porta",
  "porte.colStack": "Stack",
  "porte.colVariabile": "Variabile",
  "porte.colServizio": "Servizio",
  "porte.nessuna": "Nessuna porta assegnata",
  "porte.nessunaAiuto": "Le porte vengono assegnate al primo avvio di uno stack che ne dichiara una come variabile.",
  "porte.esterne": "Occupate fuori da Portman",
  "porte.esterneAiuto": "Container avviati da altri strumenti. Portman le evita quando assegna una porta.",


  "utenti.titolo": "Utenti",
  "utenti.intro": "Chi può accedere a Portman e con quale ruolo; ogni azione resta in Attività.",
  "utenti.nuovo": "Nuovo utente",
  "utenti.seiTu": "sei tu",
  "utenti.disattivato": "disattivato",
  "utenti.dal": (p: { quando: string }) => `dal ${p.quando}`,
  "utenti.passwordAiuto": "Almeno 12 caratteri.",
  "utenti.ruolo": "Ruolo",
  "utenti.ruoloAdmin": "gestisce utenti e impostazioni",
  "utenti.ruoloOperator": "modifica e avvia gli stack",
  "utenti.ruoloViewer": "sola lettura",
  "utenti.crea": "Crea utente",
  "utenti.modificaProfilo": "Modifica nome e password",
  "utenti.disattiva": "Disattiva",
  "utenti.riattiva": "Riattiva",
  "utenti.disattivaConferma": (p: { nome: string }) =>
    `Disattivare ${p.nome}? Le sue sessioni si chiudono e non potrà più accedere finché non lo riattivi.`,

  "profilo.titolo": "Profilo",
  "profilo.intro": "Come compari in Portman e con quale password accedi.",
  "profilo.nome": "Nome visualizzato",
  "profilo.nomeAiuto": (p: { username: string }) => `Vuoto: si mostra il nome utente, ${p.username}.`,
  "profilo.salvaNome": "Salva nome",
  "profilo.nomeSalvato": "Nome salvato.",
  "profilo.password": "Cambia password",
  "profilo.passwordIntro": "Dopo il cambio si chiudono tutte le tue sessioni, anche questa: si rientra con la password nuova.",
  "profilo.passwordAttuale": "Password attuale",
  "profilo.passwordNuova": "Password nuova",
  "profilo.passwordConferma": "Ripeti la password nuova",
  "profilo.passwordDiverse": "Le due password nuove non coincidono.",
  "profilo.cambiaPassword": "Cambia password",

  "import.titolo": "Importa uno stack esistente",
  "import.intro":
    "Portman ricostruisce la configurazione leggendo i container presenti sull'host: immagini, variabili, porte, volumi e reti. " +
    "Utile per portare qui uno stack avviato con altri strumenti, senza riscriverlo.",
  "import.vuoto": "Nessun progetto Compose sull'host",
  "import.vuotoAiuto": "Vengono rilevati i container avviati con Docker Compose, anche se fermi.",
  "import.attivi": (p: { attivi: number; totale: number }) => `${p.attivi}/${p.totale} attivi`,
  "import.giaGestito": "già in Portman",
  "import.esamina": "Esamina",
  "import.ricostruita": (p: { progetto: string }) => `Configurazione ricostruita da "${p.progetto}"`,
  "import.note": "Da tenere presente",
  "import.composeRicostruito": "docker-compose.yml ricostruito",
  "import.titoloEditor": (p: { progetto: string }) => `${p.progetto} · compose ricostruito`,
  "import.sensibili":
    "I valori sensibili sono stati estratti dal compose: qui vengono cifrati, mentre nel compose resterebbero in chiaro nello storico delle revisioni.",
  "import.nome": "Nome dello stack in Portman",
  "import.importa": "Importa",
  "import.dopo": "Lo stack nasce salvato ma non avviato: i container continuano a girare come adesso.",
};
